'use strict';

/**
 * Enable carousel swipe functionality for touch enabled devices and mouse click.
 *
 * This function adds event listeners for touchstart, mousedown, touchend, and mouseup
 * events on elements with the class "carousel". When a touchstart or mousedown event
 * occurs, it records the starting x-coordinate of the event. When a touchend or mouseup
 * event occurs, it compares the ending x-coordinate with the starting x-coordinate.
 * If the difference is greater than 50, it triggers the carousel to advance to the
 * next slide. If the difference is less than -50, it triggers the carousel to go to
 * the previous slide.
 */
function enableCarouselSwipe() {
    var startX;
    var endX;
    $('.carousel').on('touchstart mousedown', function (e) {
        startX = (e.type === 'touchstart' ? e.originalEvent.touches[0].clientX : e.clientX);
    });

    $('.carousel').on('touchend mouseup', function (e) {
        endX = e.type === 'touchend' ? e.originalEvent.changedTouches[0].clientX : e.clientX;
        if (startX - endX > 50) {
            $(this).carousel('next');
        } else if (startX - endX < -50) {
            $(this).carousel('prev');
        }
    });
}

$(document).ready(function () {
    enableCarouselSwipe();
});
